import { render, staticRenderFns } from "./NotificationsActivationWizard.vue?vue&type=template&id=bdca2206&scoped=true"
import script from "./NotificationsActivationWizard.vue?vue&type=script&lang=ts"
export * from "./NotificationsActivationWizard.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsActivationWizard.vue?vue&type=style&index=0&id=bdca2206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdca2206",
  null
  
)

export default component.exports